import {
  GET_HDOP,
  GET_HDOP_ERROR,
  GET_HDOP_SUCCESS,
  GET_FATIGUE,
  GET_FATIGUE_ERROR,
  GET_FATIGUE_SUCCESS,
  GET_CHECKS,
  GET_CHECKS_ERROR,
  GET_CHECKS_SUCCESS,
  GET_FRENTES,
  GET_FRENTES_ERROR,
  GET_FRENTES_SUCCESS,
} from './Recomendations.actions';

const userState = {
  hdop: [],
  fatigue: [],
  checks: [],
  frentes: [],
  loading_hdop: false,
  error_hdop: undefined,
  loading_fatigue: false,
  error_fatigue: undefined,
  loading_checks: false,
  error_checks: undefined,
  loading_frentes: false,
  error_frentes: undefined,
};

/**
 * The Driver reducer.
 */
const userReducer = (state = userState, { payload, type }) => {
  switch (type) {
    case GET_HDOP: {
      return {
        ...state,
        loading_hdop: true,
        error_hdop: undefined,
      };
    }
    case GET_HDOP_ERROR: {
      return {
        ...state,
        loading_hdop: false,
        error_hdop: payload.error,
      };
    }
    case GET_HDOP_SUCCESS: {
      return {
        ...state,
        loading_hdop: false,
        error_hdop: undefined,
        hdop: payload.hdop,
      };
    }
    case GET_FATIGUE: {
      return {
        ...state,
        loading_fatigue: true,
        error_fatigue: undefined,
      };
    }
    case GET_FATIGUE_ERROR: {
      return {
        ...state,
        loading_fatigue: false,
        error_fatigue: payload.error,
      };
    }
    case GET_FATIGUE_SUCCESS: {
      return {
        ...state,
        loading_fatigue: false,
        error_fatigue: undefined,
        fatigue: payload.fatigue,
      };
    }
    case GET_CHECKS: {
      return {
        ...state,
        loading_checks: true,
        error_checks: undefined,
      };
    }
    case GET_CHECKS_ERROR: {
      return {
        ...state,
        loading_checks: false,
        error_checks: payload.error,
      };
    }
    case GET_CHECKS_SUCCESS: {
      return {
        ...state,
        loading_checks: false,
        error_checks: undefined,
        checks: payload.checks,
      };
    }
    case GET_FRENTES: {
      return {
        ...state,
        loading_frentes: true,
        error_frentes: undefined,
      };
    }
    case GET_FRENTES_ERROR: {
      return {
        ...state,
        loading_frentes: false,
        error_frentes: payload.error,
      };
    }
    case GET_FRENTES_SUCCESS: {
      return {
        ...state,
        frentes: payload.frentes,
        loading_frentes: false,
        error_frentes: undefined,
      };
    }
    default:
      return state;
  }
};

export default userReducer;
